function KeyMapper( ) {
  this.keyMappings = [];
}

// ***************************************************************************
// Purpose: prototype function to add key map 
// Parameters: 
// key: the value of the key pressed
// callback: the callback function that will be executed when key is  pressed
// ctrl: test to see if ctrl key is down
// alt: test to see if alt key is down
// shift: test to see if shift key is down 
// ****************************************************************************
KeyMapper.prototype.addKeyMap = function( key, callback, ctrl, alt, shift, defaultPrevent ) {
  const ctrlKey = ctrl === undefined ? false : ctrl;
  const altKey = alt === undefined ? false : alt;
  const shiftKey = shift === undefined ? false : shift;
  const defaultPreventValue = defaultPrevent === undefined ? false : defaultPrevent;
  this.keyMappings.push( {key: key, callback: callback, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey, defaultPrevent: defaultPreventValue } );
};


// ***************************************************************************
// Purpose: prototype function to test if the key has been pressed
// Parameters: 
// event: passed event args from calling event 
// ****************************************************************************
KeyMapper.prototype.testKeyMap = function( event ) {
  if( this.keyMappings !== undefined ) {
    if( this.keyMappings.length > 0 ) {
      for( var index = 0;index < this.keyMappings.length; index++ ) {
        const keyMap = this.keyMappings[ index ];
        if( event.key === keyMap.key ) {
          if( ( event.ctrlKey !== keyMap.ctrlKey ) || 
              ( event.altKey !== keyMap.altKey ) || 
              ( event.shiftKey !== keyMap.shiftKey ) ) {
            continue;
          } else {
            if( keyMap !== undefined && keyMap !== null ) {
              if( event !== undefined && event !== null ) {
                event.cancel = false;
                keyMap.callback( event );
                if( ( keyMap.defaultPrevent ) === true && ( event.cancel === false ) ) {
                  event.preventDefault();
                }
              }
            }
          }
          return;
        }
      }
    }
  }
};

export default KeyMapper;


// WEBPACK FOOTER //
// ./src/prototypes/KeyMapper.js